import React, { useEffect, useState } from 'react'

/**
 * The mount point for the mock site's floating panel (docs/mock-site.md).
 *
 * Rendered by wrapPageElement in BOTH gatsby-browser.js and gatsby-ssr.js, so
 * the server HTML and the first client render agree: both see null. The
 * panel itself arrives after mount, through a dynamic import guarded by the
 * literal build flag — a build without GATSBY_MOCK_MODE folds `Panel` to null
 * and never emits the chunk, which is the whole of the production guarantee
 * (src/utils/featureFlags.ts isMockModeEnabled).
 */
const Panel =
  process.env.GATSBY_MOCK_MODE === 'true' ? React.lazy(() => import('./panel/MockPanel')) : null

const MockMount: React.FC = () => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  if (Panel === null || !mounted) return null
  return (
    <React.Suspense fallback={null}>
      <Panel />
    </React.Suspense>
  )
}

export default MockMount
